export default null;throw new Error("Unable to resolve \"./packer-sync\" from npm:pngjs@5.0.0/browser.js");